// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "pfx-CommunityGroupForm-module__container--Xrv4W";
var _7 = "1140px";
var _8 = "940px";
var _9 = "100%";
var _a = "15px";
var _b = "620px";
var _c = "#f53535";
var _d = "rgba(0,0,0,.2)";
var _e = "rgba(255,255,255,.38)";
var _f = ".38";
var _10 = "pfx-CommunityGroupForm-module__error-banner--ztym8";
var _11 = "rgba(255,255,255,.2)";
var _12 = "#0025ff";
var _13 = "pfx-CommunityGroupForm-module__glitch-anim--ZAKb_";
var _14 = "pfx-CommunityGroupForm-module__glitch-anim-2--k7R_4";
var _15 = "#f60";
var _16 = "#41ead4";
var _17 = "#2cdd78";
var _18 = "#66ab23";
var _19 = "#f5f5f5";
var _1a = "#c3c3c3";
var _1b = "#ececec";
var _1c = "#252525";
var _1d = "#272727";
var _1e = "#c6c6c5";
var _1f = "#333";
var _20 = "#3c3c3c";
var _21 = "#9c9b9b";
var _22 = "#8c8c8c";
var _23 = "#6f6f6e";
var _24 = "#3c3c3b";
var _25 = "#373737";
var _26 = "#6a6a69";
var _27 = "#6f6f6f";
var _28 = "#9f9e9e";
var _29 = "#282828";
var _2a = "#828181";
var _2b = "#1d1d1d";
var _2c = "#979797";
var _2d = "#9c9b9b";
var _2e = "#a7a7a6";
var _2f = "#c6c6c5";
var _30 = "#d8d8d7";
var _31 = "#dddddc";
var _32 = "72px";
var _33 = "40px";
var _34 = "36px";
var _35 = "25px";
var _36 = "18px";
var _37 = "13px";
var _38 = "pfx-CommunityGroupForm-module__inner-container--xEBqd";
var _39 = "#0025ff";
var _3a = "rgba(255,255,255,.12)";
var _3b = "#6535f5";
var _3c = "2px";
var _3d = "56px";
var _3e = "56px";
var _3f = "#41ead4";
var _40 = "#f60";
var _41 = "#f83600";
var _42 = "#881f00";
var _43 = "18px";
var _44 = "15px";
var _45 = "pfx-CommunityGroupForm-module__pfx-icon--fgvOV";
var _46 = "red";
var _47 = "13px";
var _48 = "rgba(255,255,255,.07)";
var _49 = "pfx-CommunityGroupForm-module__title--a702w";
var _4a = "#35465c";
var _4b = "#55acee";
var _4c = "#fff";
var _4d = "#ffce36";
var _4e = "#ffcd00";
var _4f = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "container", _7 as "containerLarge", _8 as "containerMedium", _9 as "containerMobile", _a as "containerPaddingMobile", _b as "containerSmall", _c as "danger", _d as "darkElement", _e as "disabled", _f as "disabledOpacity", _10 as "errorBanner", _11 as "extraLightElement", _12 as "facebook", _13 as "glitchAnim", _14 as "glitchAnim2", _15 as "google", _16 as "green", _17 as "green2", _18 as "greenColor", _19 as "grey1", _1a as "grey10", _1b as "grey2", _1c as "grey25", _1d as "grey27", _1e as "grey3", _1f as "grey33", _20 as "grey3C", _21 as "grey4", _22 as "grey41", _23 as "grey5", _24 as "grey6", _25 as "grey61", _26 as "grey6A", _27 as "grey6F", _28 as "grey7", _29 as "grey8", _2a as "grey82", _2b as "grey9", _2c as "grey97", _2d as "grey9C", _2e as "greyA7", _2f as "greyC6", _30 as "greyD8", _31 as "greyDd", _32 as "header1", _33 as "header2", _34 as "header3", _35 as "header4", _36 as "header5", _37 as "header6", _38 as "innerContainer", _39 as "klein", _3a as "lightElement", _3b as "lilac", _3c as "menuBorder", _3d as "menuHeight", _3e as "menuMobileHeight", _3f as "ocean", _40 as "orange", _41 as "orange2", _42 as "orangeDark", _43 as "paragraph", _44 as "paragraphSmall", _45 as "pfxIcon", _46 as "red", _47 as "subHeaderSmall", _48 as "subtleLightElement", _49 as "title", _4a as "tumblr", _4b as "twitter", _4c as "white", _4d as "yellow", _4e as "yellowDeep", _4f as "youtube" }
